import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { EventWorkspace } from "@/features/events/EventWorkspace";

export const Route = createFileRoute("/portal/eventos/$id")({ component: PortalEvent });
function PortalEvent() {
  const { id } = Route.useParams();
  return (
    <div className="space-y-6">
      <Link
        to="/portal"
        className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="size-4" /> Mis eventos
      </Link>
      <EventWorkspace eventId={id} admin={false} />
    </div>
  );
}
